import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';
import { secondaryFont } from 'src/theme/typography';

const StyledTextGradient = styled(m.h1)(({ theme }) => ({
  background: '-webkit-linear-gradient(0deg, #164732, #51B949)',
  '-webkit-background-clip': 'text',
  '-webkit-text-fill-color': 'transparent',
  textTransform: 'uppercase',
  fontSize: `35px`,
  fontFamily: secondaryFont,
}));

// ----------------------------------------------------------------------

export default function AboutView() {
  const { t } = useLocales();

  const mdDown = useResponsive('down', 'md');

  return (
    <Container>
      <Stack pt={6}>
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} sm={8} md={8}>
            <Stack position="relative">
              <Box
                component="img"
                srcSet="/assets/images/about/about-us-001.png 2x"
                alt=""
                width="100%"
              />
              <Typography
                sx={{
                  fontFamily: secondaryFont,
                  fontSize: mdDown ? 16 : 35,
                  textTransform: 'uppercase',
                  fontWeight: '700',
                  color: '#fff',
                  textAlign: 'center',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '100%',
                  transform: 'translate(-50%,-50%)',
                }}
              >
                {t('string_092')}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={8} md={4}>
            <StyledTextGradient>1.</StyledTextGradient>
            <Typography fontSize={16}>{t('string_085')}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} sm={8} md={8}>
            <Stack position="relative">
              <Box
                component="img"
                srcSet="/assets/images/about/about-us-002.png 2x"
                alt=""
                width="100%"
              />
              <Typography
                sx={{
                  fontFamily: secondaryFont,
                  fontSize: mdDown ? 16 : 35,
                  textTransform: 'uppercase',
                  fontWeight: '700',
                  color: '#fff',
                  textAlign: 'center',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '100%',
                  transform: 'translate(-50%,-50%)',
                }}
              >
                {t('string_093')}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={8} md={4}>
            <StyledTextGradient>2.</StyledTextGradient>
            <Typography fontSize={16}>{t('string_086')}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} sm={8} md={8}>
            <Stack position="relative">
              <Box
                component="img"
                srcSet="/assets/images/about/about-us-003.png 2x"
                alt=""
                width="100%"
              />
              <Typography
                sx={{
                  fontFamily: secondaryFont,
                  fontSize: mdDown ? 16 : 35,
                  textTransform: 'uppercase',
                  fontWeight: '700',
                  color: '#fff',
                  textAlign: 'center',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '100%',
                  transform: 'translate(-50%,-50%)',
                }}
              >
                {t('string_094')}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={8} md={4}>
            <StyledTextGradient>3.</StyledTextGradient>
            <Typography fontSize={16}>{t('string_087')}</Typography>
          </Grid>
        </Grid>

        <Stack py={12} position="relative">
          <StyledTextGradient
            sx={{ fontSize: mdDown ? 20 : 55, position: 'absolute', top: '20%', left: '10%' }}
          >
            {t('string_088')}
          </StyledTextGradient>
          <Box component="img" srcSet="/assets/images/about/about-us-004.png 2x" alt="" />
        </Stack>
      </Stack>
    </Container>
  );
}
